<template>
  <el-dialog
    :title="isEdit ? $t('text.edit_patient') : $t('text.add_patient')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="true"
    :lock-scroll="true"
    :modal-append-to-body="true"
    :append-to-body="true"
    @close="closeDialog()"
    width="800px"
    class="edit-patient"
    v-if="dialogVisible"
  >
    <div>
      <div class="step-wrapper">
        <el-steps
          :active="activeCard"
          finish-status="success"
          simple
          class="add-patient-step"
          :class="isEdit ? 'clickable-step' : ''"
        >
          <el-step
            :title="$t('text.details')"
            icon="el-icon-info"
            @click.native="goTab(0)"
            :status="isEdit ? 'process' : ''"
            :class="activeCard === 0 ? 'active-step' : ''"
          ></el-step>
          <el-step
            :title="$t('text.facility_setup')"
            icon="el-icon-office-building"
            @click.native="goTab(1)"
            :status="isEdit ? 'process' : ''"
            :class="activeCard === 1 ? 'active-step' : ''"
          ></el-step>
          <el-step
            :title="$t('text.Devices')"
            icon="el-icon-box"
            @click.native="goTab(2)"
            :status="isEdit ? 'process' : ''"
            :class="activeCard === 2 ? 'active-step' : ''"
          ></el-step>
          <el-step
            :title="$t('text.products')"
            icon="el-icon-help"
            @click.native="goTab(3)"
            :status="isEdit ? 'process' : ''"
            :class="activeCard === 3 ? 'active-step' : ''"
          ></el-step>
        </el-steps>
      </div>
      <PatientDetailSection
        ref="patientDetailSection"
        v-show="activeCard === 0"
      />
      <PatientBuildingSection
        ref="patientBuildingSection"
        v-show="activeCard === 1"
      />
      <PatientDeviceSection
        ref="patientDeviceSection"
        v-show="activeCard === 2"
      />
      <PatientProductsSection
        ref="patientProductsSection"
        v-show="activeCard === 3"
      />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button
        type="text"
        class="back-btn"
        v-if="activeCard !== 0"
        @click="back()"
        ><i class="el-icon-arrow-left mr-5"></i
        >{{ $t('text.back').toUpperCase() }}</el-button
      >
      <span v-if="isEdit">
        <el-button
          class="common-btn min-w-80"
          @click="submit()"
          :loading="saveLoading"
          >{{ $t('text.save').toUpperCase() }}</el-button
        >
      </span>
      <span v-else>
        <el-button
          class="common-btn min-w-80"
          @click="submit()"
          :loading="saveLoading"
          v-if="activeCard === 3"
          >{{ $t('text.add').toUpperCase() }}</el-button
        >
        <el-button class="common-btn min-w-80" @click="next()" v-else>{{
          $t('text.continue').toUpperCase()
        }}</el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import PatientDetailSection from '@/components/manage/patients/editPatient/PatientDetailSection.vue'
import PatientBuildingSection from '@/components/manage/patients/editPatient/PatientBuildingSection.vue'
import PatientDeviceSection from '@/components/manage/patients/editPatient/PatientDeviceSection.vue'
import PatientProductsSection from '@/components/manage/patients/editPatient/PatientProductsSection.vue'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dialogVisible: false,
      activeCard: 0,
      saveLoading: false,
      isEdit: false
    }
  },
  props: {
    shouldRedirectDashboard: {
      type: Boolean,
      require: false,
      default: true
    },
    reFetchPatients: {
      type: Boolean,
      require: false,
      default: true
    }
  },
  components: {
    PatientDetailSection,
    PatientBuildingSection,
    PatientDeviceSection,
    PatientProductsSection
  },
  methods: {
    goTab(index) {
      if (!this.isEdit) return false
      this.activeCard = index
    },
    next() {
      let valid = false
      if (this.activeCard === 0) {
        this.$refs.patientDetailSection.$refs.form.validate(res => {
          valid = res
        })
      }
      if (this.activeCard === 1) {
        this.$refs.patientBuildingSection.$refs.form.validate(res => {
          valid = res
        })
      }
      if (this.activeCard === 2) {
        this.$refs.patientDeviceSection.$refs.form.validate(res => {
          valid = res
        })
      }
      if (valid) {
        this.activeCard++
      }
    },
    back() {
      this.activeCard--
    },
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.$refs.patientDetailSection.form.PatientId = 0
      this.$refs.patientBuildingSection.form.PatientId = 0
      this.$refs.patientDeviceSection.form.PatientId = 0
      this.$refs.patientProductsSection.form.PatientId = 0

      this.$refs.patientDetailSection.$refs.form.resetFields()
      this.$refs.patientBuildingSection.$refs.form.resetFields()
      this.$refs.patientDeviceSection.$refs.form.resetFields()
      this.$refs.patientProductsSection.$refs.form.resetFields()
      this.activeCard = 0
      this.isEdit = false
      this.dialogVisible = false
    },
    submit() {
      let detailValid = false
      let buildingValid = false
      let deviceValid = false
      let productValid = false
      this.$refs.patientDetailSection.$refs.form.validate(valid => {
        detailValid = valid
      })
      this.$refs.patientBuildingSection.$refs.form.validate(valid => {
        buildingValid = valid
      })
      this.$refs.patientDeviceSection.$refs.form.validate(valid => {
        deviceValid = valid
      })
      this.$refs.patientProductsSection.$refs.form.validate(valid => {
        // User should be able to use just day product or night product. Both are not necessary
        let dayProduct = this.$refs.patientProductsSection.form.DayProductId
        let nightProduct = this.$refs.patientProductsSection.form.NightProductId

        let dayProductValid = dayProduct && dayProduct > 0
        let nightProductValid = nightProduct && nightProduct > 0
        productValid = valid && (dayProductValid || nightProductValid)
        if (!dayProductValid && !nightProductValid) {
          swal({
            icon: 'warning',
            title: 'Warning',
            text: this.$t('text.please_select_one_product')
          })
        }
      })
      if (!detailValid) {
        this.activeCard = 0
      } else if (!buildingValid) {
        this.activeCard = 1
      } else if (!deviceValid) {
        this.activeCard = 2
      } else if (!productValid) {
        this.activeCard = 3
      }
      if (detailValid && buildingValid && deviceValid && productValid) {
        this.save()
      }
    },
    save() {
      let patient = {
        ...this.$refs.patientDetailSection.form,
        ...this.$refs.patientBuildingSection.form,
        ...this.$refs.patientDeviceSection.form,
        ...this.$refs.patientProductsSection.form,
        PrivacyPolicy: true,
        DevicePolicy: true,
        MarketingPolicy: true,
        IsUrine: true,
        WaistSize: 1,
        Weight: 1,
        RedMultiplier: 1,
        GroupId: []
      }
      this.saveLoading = true
      this.$store
        .dispatch('patient/savePatient', patient)
        .then(response => {
          this.saveLoading = false
          if (response.data.success) {
            this.closeDialog()
            if (this.shouldRedirectDashboard) {
              this.$router.push({
                path: '/dashboard',
                query: { hightLightPatientId: response.data.data.PatientId }
              })
            }
            if (this.reFetchPatients) {
              this.$store.dispatch('patient/fetchPatients')
            }
            this.$emit('saveSuccess')
          }
        })
        .catch(() => {
          this.saveLoading = false
        })
    }
  }
}
</script>
